import common from './es/pages/common';
import dashboard from './es/pages/dashboard';
import account from './es/pages/account';
import vendors from './es/pages/vendors';
import auth from './es/pages/auth';
import guests from './es/pages/guests';
import budget from './es/pages/budget';
import timeline from './es/pages/timeline';
import subscription from './es/pages/subscription';
import events from './es/pages/events';
import notifications from './es/pages/notifications';
import theme from './es/theme';
import invitation from './es/pages/invitation';
import collaborators from './es/pages/collaborators';
import languages from './es/pages/languages';
import access from './es/pages/access';
import settings from './es/pages/settings';

import legal from './es/pages/legal';
import achievements from './es/pages/achievements';
import taskTemplates from './es/taskTemplates';
import debug from './es/debug';

export default {
  ...common,
  common,
  currentEvent: "Evento Actual",
  dashboard,
  account,
  vendors,
  auth,
  guests,
  budget,
  timeline,
  subscription,
  events,
  notifications,
  theme: {
    ...theme,
    light: "Claro",
    dark: "Oscuro",
    system: "Sistema"
  },
  invitation,
  collaborators,
  languages,
  access,
  ...settings,
  legal,
  achievements,
  taskTemplates,
  debug
};
